import template from './settings.html';
import controller from './settings.controller';

const taxationSettingsComponent = {
  restrict: 'E',
  template,
  controller
};

export default taxationSettingsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/settings/settings.component.js
 **/